export const settings$6 = {
  unlockScrollDelay: 400,
};
export const settings$4 = {
  cartDrawerEnabled: window.theme.settings.cartType === 'drawer',
  timers: {
    addProductTimeout: 1000,
  },
  animations: {
    data: 'data-aos',
    method: 'fade-up',
  },
};
export const settings$3 = {
  moveTime: 1.63, // 100px going to move for 1.63s
  space: 100, // 100px
};
export const settings$2 = {
  row: 'row',
  columns: 'columns',
};
export const settings$1 = {
  hide: 'hide',
  showMessage: 'show-message',
};

export const settings$9 = {
  animationDelay: 500,
};

export const settings$8 = {
  loadingTimeout: 300,
};

export const settings$7 = {
  templateIndex: 1,
};

export const settings$5 = {
  templateIndex: 0,
};

export const settings = {
  intersectionRatio: 0.5,
  scrollDirection: {
    horizontal: 'horizontal',
    horizontalReversed: 'horizontal-reversed',
    vertical: 'vertical',
    verticalReversed: 'vertical-reversed',
  },
  typeOfIntersecting: {
    maxVisibility: 'maximum-visibility-of-each-image-in-viewport',
    middleOfViewport: 'image-in-the-middle-of-viewport',
  },
};
